import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  getActive () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}region/all`, AUTH_HEADERS())
  },
  getArchived () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}region/all?archived=true&offset=0`, AUTH_HEADERS())
  },
  create (region) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}region`, region, AUTH_HEADERS())
  },
  update (id, region) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}region/${id}`, region, AUTH_HEADERS())
  },
  archive (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}region/archive/${id}`, AUTH_HEADERS())
  },
  restore (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}region/restore/${id}`, AUTH_HEADERS())
  }
}
